<template>
  <v-container class="fill-height justify-center">
    <v-card outlined class="rounded-xl pa-6 text-center" max-width="420">
      <v-progress-circular v-if="!error" indeterminate color="primary" class="mb-4" />
      <v-icon v-else color="error" size="42" class="mb-4">mdi-alert-circle-outline</v-icon>
      <h1 class="text-h6 mb-2">{{ error ? "Could not open RepairNest" : "Opening RepairNest" }}</h1>
      <p class="mb-4">{{ error || "Connecting your account securely…" }}</p>
    </v-card>
  </v-container>
</template>

<script>
import authService from "@/modules/Authentication/service";

export default {
  name: "LivePortalHandoff",
  data: () => ({ error: "" }),
  async created() {
    const code = new URLSearchParams(window.location.hash.slice(1)).get("code");
    // The fragment must not survive a reload, error, or navigation.
    window.history.replaceState(window.history.state, "", window.location.pathname);
    if (!code || !/^[A-Za-z0-9_-]{43}$/.test(code)) {
      this.error = "This sign-in link is missing or invalid. Please sign in again.";
      return;
    }
    try {
      const session = await authService.exchangeMobileHandoff(code);
      if (!session || !session.token || !session.organizationId) throw new Error("Incomplete session");
      localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`, session.token);
      localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`, session.organizationId);
      this.$router.replace("/home");
    } catch (error) {
      this.error = "The connection expired or could not be completed. Please sign in again.";
    }
  },
};
</script>
